var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BSCTabs"},[_vm._l((_vm.tabs),function(cell,index){return _c('div',{key:index,ref:"tabItem",refInFor:true,staticClass:"BSCTabs-item",class:[
      `is-${_vm.type}`,
      { 'BSCTabs-item-selected': cell == _vm.tabs[_vm.currentElementIndex] }
    ],on:{"click":function($event){return _vm.selected(cell)}}},[_vm._v(" "+_vm._s(cell.label)+" ")])}),_c('div',{ref:"selectedItem",staticClass:"selectedItem",class:[`is-${_vm.type}`]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }